<template>
    <component :is="template">
        <div class="gift">
            <div>
                <div class="tit-wrap tit-wrap--unberline">
                    <h2 class="tit">이벤트 참여내역</h2>
                </div>
            </div>

            <div class="mt-4">
                <div>
                    <v-data-table :items="logs" :headers="logsHeaders" hide-default-footer disable-pagination disable-sort class="v-data-table--sm">
                        <span slot="item.eventname">보물찾기</span>
                        <span slot="item.isPayment" slot-scope="{item}">{{ item.isPayment === false ? "미지급" : "지급"}}</span>
                        <span slot="item.createdAt" slot-scope="{item}">{{ $dayjs(item.createdAt).format("YYYY-MM-DD HH:mm:ss") }}</span>
                    </v-data-table>
                </div>
            </div>

            <div class="mt-30px mt-md-40px">
                <v-pagination v-model="page" :length="pageCount" total-visible="11" @input="init()"/>
            </div>
        </div>
    </component>
</template>
<script>
import api from "@/api";
export default {
    data(){
        return {
            page: 1,
            pageCount: 0,
            limit: 10,

            logs: [],

            logsHeaders: [
                { text: "이벤트명", value: "eventname", align: "center", width: "20%" },
                { text: "당첨 상품", value: "config.name", align: "center", width: "40%" },
                { text: "지급여부", value: "isPayment", align: "center", width: "20%" },
                { text: "일자", value: "createdAt", align: "center", width: "20%" },
            ]
        }
    },
    async mounted(){
        // alert("현재 작업중인 페이지입니다.")
        // this.$router.push("/")
        await this.init();
    },
    methods: {
        async init(){
            let { summary, logs } = await api.v1.me.hunt.logs.gets({
                headers: {
                    skip: (this.page - 1) * this.limit,
                    limit: this.limit
                }
            })
            this.logs = logs
            this.pageCount = Math.ceil(summary.totalCount / this.limit);
        },

    },
    computed: {
        template(){ return () => import(`@/templates/${this.$theme.pages.mypage}`); }
    },
}
</script>